var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6617 6.11416C20.5476 5.68513 20.3229 5.29356 20.01 4.97866C19.6972 4.66375 19.307 4.43655 18.8787 4.31979C17.3021 3.89583 11 3.89583 11 3.89583C11 3.89583 4.69791 3.89583 3.12124 4.31979C2.69295 4.43655 2.30283 4.66375 1.98993 4.97866C1.67704 5.29356 1.45234 5.68513 1.33832 6.11416C0.916657 7.6977 0.916656 11 0.916656 11C0.916656 11 0.916657 14.3023 1.33832 15.8858C1.45234 16.3149 1.67704 16.7064 1.98993 17.0213C2.30283 17.3362 2.69295 17.5634 3.12124 17.6802C4.69791 18.1042 11 18.1042 11 18.1042C11 18.1042 17.3021 18.1042 18.8787 17.6802C19.307 17.5634 19.6972 17.3362 20.01 17.0213C20.3229 16.7064 20.5476 16.3149 20.6617 15.8858C21.0833 14.3023 21.0833 11 21.0833 11C21.0833 11 21.0833 7.6977 20.6617 6.11416Z",
    fill: "#FF0302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80429 14.025V7.97499L14.1214 11L8.80429 14.025Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.018695b57f46e9d42cc75584f7973a76.svg";
export { ForwardRef as ReactComponent };